import CartEntity from "../cart/cart";
import CouponsEntity from "../coupons/coupon";

export interface OrderStacks {
    couponDiscount?: number;
    coupon?: Partial<CouponsEntity> | null
    grandTotal?: number
    items: CartEntity[],
    subtotalAfterCoupon?: number,
    totalItems?: number
    totalPrice?: number
    totalShipping?: number
}

export enum OrderPaymethods {
	card = 'card',
	pse = 'pse',
	nequi = 'nequi',
	cash = 'cash',
	bancolombia_transfer = 'bancolombia_transfer',
	daviplata = 'daviplata',
	payment_on_delivery = 'payment_on_delivery',
	none = 'none'
}